import React, { useContext, useState } from 'react';
import { Pressable, Text } from 'react-native';

import AuthContext from 'app/src/contexts/AuthContext';
import { SubNavContainer, LinkContainer, LinkSpace } from 'app/src/elements';
import Modal from 'app/src/elements/Modal';
import { Link } from 'app/src/utils/routing';

import NewAccount from './new';

const SubNav = ({ refetch, selects }) => {
  const { hasPolicy } = useContext(AuthContext);
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <SubNavContainer>
      <LinkContainer>
        {hasPolicy({ type: 'Account', action: 'create' }) && (
          <>
            <Pressable onPress={() => setShowAddModal(true)} >
              <Text>+ Add Account</Text>
            </Pressable>
            <LinkSpace />
            <Link to="/accounting/account-groups">
              <Text>Account Groups</Text>
            </Link>
          </>
        )}
      </LinkContainer>

      {showAddModal &&
        <Modal
          showModal
          setShowModal={setShowAddModal}
          modalType="Add Account"
        >
          <NewAccount
            setShowModal={setShowAddModal}
            refetch={refetch}
            selects={selects}
          />
        </Modal>
      }
    </SubNavContainer>
  );
};

export default SubNav;
